import { useSelector } from 'react-redux';
import { groupNotifyStatus } from '../utils/groupNotificationUtils';

/**
 * Hook to get formatted group notification text.
 * @param {Object} message - The message object containing notification details.
 * @returns {string} Formatted notification text.
 */
export const useGroupNotificationText = message => {
   const publisher = useSelector(state => state.userInfoData?.users[message?.publisherId])?.nickName || '';
   const toUser = useSelector(state => state.userInfoData?.users[message?.userId])?.nickName || '';

   if (!message || message.msgType !== 'groupProfileUpdated') return '';

   return groupNotifyStatus({
      publisherId: message.publisherId,
      toUserId: message.userId,
      status: message.profileUpdatedStatus,
      chatType: message.chatType,
      publisher,
      toUser,
   });
};
